<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="aplicacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Aplicação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <aplicacao ref="aplic" :unica="true" @refresh="refresh()"></aplicacao>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import Aplicacao from './Aplicacao.vue';

export default {
    components: {
        Aplicacao
    },

    methods: { 
        refresh () { 
            this.$emit('refresh');
        },
        
        abrir (receita) { 
            this.$refs.aplic.carregar_receita(receita.id_receita);
            $('#aplicacaoModal').modal('show');
        },
    }
}
</script>
